'use client';
import { createContext } from 'react';
const documentContext = createContext(null);
export default documentContext;
